<div class="ero">
    <div class="eroInputs">
        <span class="eroTitle">ERO Details</span>
        <div class="inputs " *ngIf="!isCustomer">
            <app-number-field [isEditable]="eroDataSource.data.length == 0" [placeholder]="'From Days'" fxFlex="12em"
                [(ngModel)]="fromDays" [minValue]="1" [label]="'From Days'" [noDecimal]="true" fxLayout="column">
            </app-number-field>
            <app-number-field [isEditable]="true" [placeholder]="'To Days'" [(ngModel)]="toDays" [minValue]="1"
                [maxValue]="agreementDays" fxFlex="12em" [label]="'To Days'" [noDecimal]="true" fxLayout="column">
            </app-number-field>
            <logzy-money-field [isEditable]="true" [(amount)]="amount" [minValue]="0"
                [(currencyCode)]="agreementCurrency" [curdisabled]="eroDataSource.data.length != 0" fxFlex="12em"
                [label]="'Amount'" fxLayout="column">
            </logzy-money-field>
            <app-mat-auto-search [(ngModel)]="penalty_from" [disabled]="eroDataSource.data.length != 0"
                [options]="penaltyTypesOptions?.actions?.POST?.penalty_from?.choices" fxFlex="12em"
                [isEditable]="eroDataSource.data.length == 0" [idField]="null" [displayField]="'display_name'"
                [name]="'penalty_from'" [searchable]="false" [clearable]="false" fxLayout="column"
                [label]="'Charged From'" *ngIf="penalty_from == null || isObject(penalty_from)"></app-mat-auto-search>
            <div style="display: grid" *ngIf="penalty_from != null && !isObject(penalty_from)">
                <div class="inputTitle"><span>Charged From</span> </div>
                <div class="viewLable"><span>
                        {{ penalty_from == 'dropoff_end_date' ?
                        'Drop-off to Agreement End Date' : 'Pick-up to Agreement End Date'}}
                    </span>
                </div>
            </div>
        </div>
        <!-- <div class="eroBtn">
        </div> -->
        <i class="flaticon-close" matTooltip="Close" matTooltipPosition="left" (click)="cancelEroDialog()"></i>
    </div>
    <mat-dialog-content>
        <div class="setTable">
            <mat-table [dataSource]="eroDataSource">
                <ng-container matColumnDef="sequence_no">
                    <mat-header-cell *matHeaderCellDef>Sr.No</mat-header-cell>
                    <mat-cell *matCellDef="let data">
                        {{ data.sequence_no }}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="fromDays">
                    <mat-header-cell *matHeaderCellDef>From Days</mat-header-cell>
                    <mat-cell *matCellDef="let data; let index = index">
                        {{data.fromDays}}
                        <!-- <app-number-field [isEditable]="false" [placeholder]="'From Days'" class="w-100i"
                            [(ngModel)]="data.fromDays" [minValue]="1">
                        </app-number-field> -->
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="toDays">
                    <mat-header-cell *matHeaderCellDef>To Days</mat-header-cell>
                    <mat-cell *matCellDef="let data; let index = index">
                        <app-number-field [isEditable]="false" [placeholder]="'To Days'" class=" justify-content-center"
                            fxFlex="8em" [(ngModel)]="data.toDays" [minValue]="data.fromDays + 1" [noDecimal]="true"
                            fxLayout="column">
                        </app-number-field>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="amount">
                    <mat-header-cell *matHeaderCellDef>Amount</mat-header-cell>
                    <mat-cell *matCellDef="let data; let index = index">
                        <logzy-money-field [isEditable]="data.isEdit" [(amount)]="data.amount" [minValue]="0"
                            fxFlex="8em" [(currencyCode)]="data.amount_currency" class="justify-content-center"
                            fxLayout="column">
                        </logzy-money-field>
                        <!-- <span *ngIf="!data.isEdit">{{ data.amount_currency }}</span> -->
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="penalty_from">
                    <mat-header-cell *matHeaderCellDef>Charged From</mat-header-cell>
                    <mat-cell *matCellDef="let data; let index = index">
                        <!-- {{data.penalty_from.display_name}} -->
                        <app-mat-auto-search [(ngModel)]="data.penalty_from"
                            [options]="penaltyTypesOptions?.actions?.POST?.penalty_from?.choices" [isEditable]="false"
                            [idField]="null" [displayField]="'display_name'" [name]="'penalty_from'"
                            [searchable]="false" [clearable]="false" fxFlex="8em" fxLayout="column"
                            *ngIf="penalty_from == null || isObject(penalty_from)"></app-mat-auto-search>
                        <span *ngIf="penalty_from != null && !isObject(penalty_from)">
                            {{ penalty_from == 'dropoff_end_date' ?
                            'Drop-off to Agreement End Date' : 'Pick-up to Agreement End Date'}}
                        </span>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="actions">
                    <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
                    <mat-cell *matCellDef="let data; let index = index">
                        <div class="d-flex">
                            <button mat-icon-button class="save-button" matTooltip="Save Changes"
                                matTooltipPosition="left" *ngIf="data.isEdit" color="primary" (click)="saveEro(data)">
                                <!-- <mat-icon>check_circle</mat-icon> -->
                                <i class="flaticon-tick"></i>
                            </button>
                            <button mat-icon-button class="save-button" matTooltip="Edit" matTooltipPosition="left"
                                color="primary" *ngIf="!data.isEdit" (click)="editEro(data)">
                                <!-- <mat-icon>edit</mat-icon> -->
                                <i class="flaticon-pencil"></i>
                            </button>
                            <button mat-icon-button class="cancel-button" matTooltip="Cancel Changes"
                                matTooltipPosition="right" color="info" *ngIf="data.isEdit" (click)="cancelEro(data)">
                                <!-- <mat-icon>cancel</mat-icon> -->
                                <i class="flaticon-close"></i>
                            </button>
                            <button mat-icon-button class="delete-button" matTooltip="Delete" matTooltipPosition="right"
                                color="warn" *ngIf="index + 1 == eroDataSource.data.length" (click)="deleteEro(index)">
                                <!-- <mat-icon>delete</mat-icon> -->
                                <i class="flaticon-delete"></i>
                            </button>
                        </div>
                    </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;" [hidden]="row.sequence_no == 0"></mat-row>
            </mat-table>
        </div>
        <mat-dialog-actions>
            <button mat-raised-button class="Cancel" (click)="cancelEroDialog()">Close</button>
            <div class="btnb" *ngIf="!isCustomer">
                <button mat-raised-button (click)="add()" class="Save"
                    [disabled]="disableSave">
                    <span *ngIf="!disableSave">
                        Add ERO Slab
                    </span>
                    <div *ngIf="disableSave" class="p03">
                        <i class="flaticon-loading spin"></i>
                        <span>Saving Ero Details...</span>
                    </div>
                </button>
            </div>
            <!-- <button mat-raised-button class="Save" [disabled]="disableSave || eroDataSource.data.length == 0"
                (click)="saveEroDetails()">
                <span *ngIf="!disableSave">
                    Save ERO Details
                </span>
                <div *ngIf="disableSave" class="p03">
                    <i class="flaticon-loading spin"></i>
                    <span>Saving Ero Details...</span>
                </div>
            </button> -->
        </mat-dialog-actions>
    </mat-dialog-content>
</div>